/** Stable compatibility names over open content IDs. New subclasses use itemTypesForSubclass. */
import { bindContent, contentCatalog, itemTypesForSubclass } from "../content/catalog"
export type ItemTypes = string
export let ArmorTypes: string[] = [...itemTypesForSubclass("armor")]
export type Armor = string
export let AmmoTypes: string[] = [...itemTypesForSubclass("ammo")]
export type Ammo = string
export let OreTypes: string[] = [...itemTypesForSubclass("ore")]
export type Ore = string
export let DrumstickTypes: string[] = [...itemTypesForSubclass("drumstick")]
export type Drumstick = string
export let CraftResourceTypes: string[] = [...itemTypesForSubclass("craftResource")]
export type CraftResource = string
export let FlowerTypes: string[] = [...itemTypesForSubclass("flower")]
export type Flower = string
export let HideTypes: string[] = [...itemTypesForSubclass("hide")]
export type Hide = string
export let MetalBarTypes: string[] = [...itemTypesForSubclass("metalBar")]
export type MetalBar = string
export let MushroomTypes: string[] = [...itemTypesForSubclass("mushroom")]
export type Mushroom = string
export let SeedTypes: string[] = [...itemTypesForSubclass("seed")]
export type Seed = string
export let ShardTypes: string[] = [...itemTypesForSubclass("shard")]
export type Shard = string
export let StrawTypes: string[] = [...itemTypesForSubclass("straw")]
export type Straw = string
export let TorchTypes: string[] = [...itemTypesForSubclass("torch")]
export type Torch = string
export let WoodTypes: string[] = [...itemTypesForSubclass("wood")]
export type Wood = string
export let ResourceTypes: string[] = [...itemTypesForSubclass("resource")]
export type Resource = string
export let WeaponTypes: string[] = [...itemTypesForSubclass("weapon")]
export type Weapon = string
export let BauldronTypes: string[] = [...itemTypesForSubclass("bauldron")]
export type Bauldron = string
export let ShirtTypes: string[] = [...itemTypesForSubclass("shirt")]
export type Shirt = string
export let ShoesTypes: string[] = [...itemTypesForSubclass("shoes")]
export type Shoes = string
export let StructureTypes: string[] = [...itemTypesForSubclass("structure")]
export type Structure = string
export let ChestTypes: string[] = [...itemTypesForSubclass("chest")]
export type Chest = string
export let DoorTypes: string[] = [...itemTypesForSubclass("door")]
export type Door = string
export let FloorTypes: string[] = [...itemTypesForSubclass("floor")]
export type Floor = string
export let RoofTypes: string[] = [...itemTypesForSubclass("roof")]
export type Roof = string
export let WallTypes: string[] = [...itemTypesForSubclass("wall")]
export type Wall = string
export let CapeTypes: string[] = [...itemTypesForSubclass("cape")]
export type Cape = string
export let KeyTypes: string[] = [...itemTypesForSubclass("key")]
export type Key = string
export let PantsTypes: string[] = [...itemTypesForSubclass("pants")]
export type Pants = string
export let ShieldTypes: string[] = [...itemTypesForSubclass("shield")]
export type Shield = string
export let AllItemTypes: ItemTypes[] = contentCatalog.items.all
export let ItemClassToTypes: Record<string, ItemTypes[]> = contentCatalog.items.classToTypes
export { itemTypesForSubclass }

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    ArmorTypes: [...(catalog.items.subClasses["armor"] || [])],
    AmmoTypes: [...(catalog.items.subClasses["ammo"] || [])],
    OreTypes: [...(catalog.items.subClasses["ore"] || [])],
    DrumstickTypes: [...(catalog.items.subClasses["drumstick"] || [])],
    CraftResourceTypes: [...(catalog.items.subClasses["craftResource"] || [])],
    FlowerTypes: [...(catalog.items.subClasses["flower"] || [])],
    HideTypes: [...(catalog.items.subClasses["hide"] || [])],
    MetalBarTypes: [...(catalog.items.subClasses["metalBar"] || [])],
    MushroomTypes: [...(catalog.items.subClasses["mushroom"] || [])],
    SeedTypes: [...(catalog.items.subClasses["seed"] || [])],
    ShardTypes: [...(catalog.items.subClasses["shard"] || [])],
    StrawTypes: [...(catalog.items.subClasses["straw"] || [])],
    TorchTypes: [...(catalog.items.subClasses["torch"] || [])],
    WoodTypes: [...(catalog.items.subClasses["wood"] || [])],
    ResourceTypes: [...(catalog.items.subClasses["resource"] || [])],
    WeaponTypes: [...(catalog.items.subClasses["weapon"] || [])],
    BauldronTypes: [...(catalog.items.subClasses["bauldron"] || [])],
    ShirtTypes: [...(catalog.items.subClasses["shirt"] || [])],
    ShoesTypes: [...(catalog.items.subClasses["shoes"] || [])],
    StructureTypes: [...(catalog.items.subClasses["structure"] || [])],
    ChestTypes: [...(catalog.items.subClasses["chest"] || [])],
    DoorTypes: [...(catalog.items.subClasses["door"] || [])],
    FloorTypes: [...(catalog.items.subClasses["floor"] || [])],
    RoofTypes: [...(catalog.items.subClasses["roof"] || [])],
    WallTypes: [...(catalog.items.subClasses["wall"] || [])],
    CapeTypes: [...(catalog.items.subClasses["cape"] || [])],
    KeyTypes: [...(catalog.items.subClasses["key"] || [])],
    PantsTypes: [...(catalog.items.subClasses["pants"] || [])],
    ShieldTypes: [...(catalog.items.subClasses["shield"] || [])],
    AllItemTypes: catalog.items.all,
    ItemClassToTypes: catalog.items.classToTypes,
}), next => {
    ArmorTypes = next.ArmorTypes
    AmmoTypes = next.AmmoTypes
    OreTypes = next.OreTypes
    DrumstickTypes = next.DrumstickTypes
    CraftResourceTypes = next.CraftResourceTypes
    FlowerTypes = next.FlowerTypes
    HideTypes = next.HideTypes
    MetalBarTypes = next.MetalBarTypes
    MushroomTypes = next.MushroomTypes
    SeedTypes = next.SeedTypes
    ShardTypes = next.ShardTypes
    StrawTypes = next.StrawTypes
    TorchTypes = next.TorchTypes
    WoodTypes = next.WoodTypes
    ResourceTypes = next.ResourceTypes
    WeaponTypes = next.WeaponTypes
    BauldronTypes = next.BauldronTypes
    ShirtTypes = next.ShirtTypes
    ShoesTypes = next.ShoesTypes
    StructureTypes = next.StructureTypes
    ChestTypes = next.ChestTypes
    DoorTypes = next.DoorTypes
    FloorTypes = next.FloorTypes
    RoofTypes = next.RoofTypes
    WallTypes = next.WallTypes
    CapeTypes = next.CapeTypes
    KeyTypes = next.KeyTypes
    PantsTypes = next.PantsTypes
    ShieldTypes = next.ShieldTypes
    AllItemTypes = next.AllItemTypes
    ItemClassToTypes = next.ItemClassToTypes
})
